import Sheet from 'shared/Sheet'
import TextField from 'shared/Forms/TextField'
import TextInput from 'shared/Inputs/TextInput'
import { PropsWithChildren } from 'react'
import { IProjectRole } from '../../projectRoles.types'

interface IProps {
  projectRole: Pick<IProjectRole, 'title' | 'description'>
  onChange: (val: string, name: string) => void
}

const ProjectRoleSheet = (props: PropsWithChildren<IProps>) => {
  return (
    <Sheet>
      <div className='flex-lines'>
        <div className='grid-form-2'>
          <TextField header='Наименование *'>
            <TextInput value={props.projectRole.title} onChange={props.onChange} name='title' placeholder='Разработчик' />
          </TextField>
        </div>
        <TextField header='Описание'>
          <TextInput
            value={props.projectRole.description}
            onChange={props.onChange}
            name='description'
            placeholder='Специалист по разработке программного обеспечения'
            required={false}
          />
        </TextField>
      </div>
      <div className='form-footer'>{props.children}</div>
    </Sheet>
  )
}

export default ProjectRoleSheet
